// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oOQ6","toggleWrap":"styles_toggleWrap__1gW6s","content":"styles_content__dSypr","selectAreaCode":"styles_selectAreaCode__3jZs3"};